import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline } from "@mui/material";
import theme from "./theme";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import MainLayout from "./components/MainLayout";
import Login from "./pages/Login";
import Pickup from "./pages/Pickup";
import MyDeliveries from "./pages/MyDeliveries";
import DeliveryHistory from "./pages/DeliveryHistory";

function Tab({ children }) {
  return (
    <ProtectedRoute>
      <MainLayout>{children}</MainLayout>
    </ProtectedRoute>
  );
}

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route
              path="/"
              element={
                <Tab>
                  <Pickup />
                </Tab>
              }
            />
            <Route
              path="/my-deliveries"
              element={
                <Tab>
                  <MyDeliveries />
                </Tab>
              }
            />
            <Route
              path="/history"
              element={
                <Tab>
                  <DeliveryHistory />
                </Tab>
              }
            />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}
